import React from "react"
import Breadcrumbs from "~/ui-rtk/components/layout/Breadcrumbs"

type TDashboardBreadcrumbsProps = {
  slug: string
  title: string
  parent: {
    slug: string
    title: string
  }
}

const DashboardBreadcrumbs: React.FC<TDashboardBreadcrumbsProps> = ({
  slug,
  title,
  parent,
}) => (
  <div className="text-start">
    <Breadcrumbs
      items={[
        {
          slug: parent.slug,
          name: parent.title,
        },
        {
          slug,
          name: title,
        },
      ]}
    />
  </div>
)

export default DashboardBreadcrumbs
